<template>
    <div class="v2-tab-content">
        <div class="page-section">
            <a-card :bordered="false" style="width: 100%">
                <template slot="title">
                    <div class="v2-tab-hd">
                        <h2>Visita #{{ order.checkin_id }}</h2>
                    </div>
                </template>
                <template slot="extra">
                    <a-button v-if="canOpenVisit" @click="$router.push(`/visitas/${order.checkin_id}`)">
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        Abrir visita
                    </a-button>
                </template>

                <a-row type="flex" :gutter="[24, 16]">
                    <a-col v-for="info in infos" :key="info.label" style="flex: 1 1 0; min-width: 160px">
                        <div class="info-label">{{ info.label }}</div>
                        <div class="info-value">{{ info.value }}</div>
                        <div v-if="info.hint" class="info-hint">{{ info.hint }}</div>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </div>
</template>

<script>
import visitFormat from "@/pages/visits/visit-format.mixin";
import { has_feature, VISITS } from "@/helpers/features";

export default {
    name: "SellerOrderVisitTab",
    mixins: [visitFormat],
    props: {
        order: { type: Object, required: true },
    },
    computed: {
        canOpenVisit() {
            return has_feature(VISITS);
        },
        infos() {
            const visit = this.order.visit || {};
            const store = this.order.store || {};
            return [
                { label: "Loja", value: store.name || "--", hint: [store.address, store.city, store.state].filter(Boolean).join(" · ") },
                { label: "Vendedor", value: this.order.seller ? this.order.seller.name : "--", hint: this.order.provider ? this.order.provider.name : null },
                { label: "Check-in", value: this.formatDateTime(visit.checked_in_at), hint: this.distanceHint(visit.checkin_distance_m) },
                { label: "Check-out", value: this.formatDateTime(visit.checked_out_at), hint: this.distanceHint(visit.checkout_distance_m) },
                { label: "Duração", value: this.formatDuration(this.durationBetween(visit.checked_in_at, visit.checked_out_at)) },
            ];
        },
    },
    methods: {
        distanceHint(meters) {
            return meters === null || meters === undefined ? "Sem localização" : `${this.formatDistance(meters)} da loja`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/pages/visits/_detail-page";
</style>
